import React, { Suspense } from 'react';
import { Box, Text, useTheme } from '@chakra-ui/react';
import { useIntl } from 'react-intl';

import { Headline } from '@ldp-web/component-library/ui/molecules/headline';
import { Spinner } from '@/components/shared';

import {
  ComponentItem,
  Service,
  IPharmacistInformation,
} from '@/components/pharmacy-and-services/pharmacy-and-services.interface';
import { IPharmacyCareClinicProps } from './pharmacy-care-clinic.interface';
import StoreInformation from '../store-information';
import PharmacistInformation from '@/components/pharmacist-information/pharmacist-information.component';
import { TStoreDetailsResults } from '@/components/store-details/store-details.interface';

const getComponentData = (layout: IPharmacyCareClinicProps['layout']) => {
  const findComponent = (componentId: string) =>
    layout?.sections?.mainContentCollection?.components?.find(
      (item: ComponentItem) => item.componentId === componentId
    );

  return {
    services: findComponent('clinicServicesComponent')?.data as Service[],
    pharmacistInformation: findComponent('pharmacistInfoComponent') as IPharmacistInformation,
    storeDetails: findComponent('storeDetailsComponent')?.data as TStoreDetailsResults,
  };
};

const PharmacyCareClinic: React.FC<IPharmacyCareClinicProps> = ({ layout, storeId }) => {
  const { common } = useTheme();
  const { formatMessage } = useIntl();
  const { pharmacistInformation, storeDetails } = getComponentData(layout);
  const { province, storeType } = storeDetails;

  return (
    <Suspense fallback={<Spinner />}>
      <Box style={{ marginBottom: '2rem' }}>
        <Headline
          title={formatMessage({ id: 'pharmacyCareClinicHeader' })}
          data-testid="pharmacy-care-clinic-headline"
          headlineSize={3}
        />
        <Text data-testid="pharmacy-care-clinic-description" {...common?.common02Regular}>
          {formatMessage({ id: 'pharmacyCareClinicDescription' })}
        </Text>
      </Box>
      <StoreInformation layout={layout} activeIndex={2} />
      <PharmacistInformation
        storeId={storeId}
        province={province}
        pharmacistInformation={pharmacistInformation}
        storeType={storeType}
      />
    </Suspense>
  );
};

export default PharmacyCareClinic;
